module.exports = __webpack_public_path__ + "img/Aspiration of an urban transformation in Asia.94c4f347.jpg";